module.exports = __webpack_public_path__ + "static/media/subscribe.312e59d8.png";